import React from "react"
import {useTranslation} from "react-i18next"
import {AppBar, Toolbar, Avatar, Button, useTheme, useMediaQuery} from "@material-ui/core"

// HOCs
import withUser, {WithUserProps} from "../../modules/auth/hoc/withUser"

// Components
import SignOutButton from "../../modules/auth/components/SignOutButton"
import UiSkinToggle from "../../modules/ui-skin/components/UiSkinToggle"

// Styles
import useStyles from "./styles"

// Constants
import {languageLabel, supportedLanguages} from "../../translations/languages"

// Helpers
declare var Title: any;

type HeaderProps = {} & WithUserProps

/**
 * @param props
 */
function Header(props: HeaderProps) {
    const styles = useStyles();
    const {user} = props;
    const [, i18n] = useTranslation()
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.down("sm"));

    const getUserEmail = () => {
        if (user && user.email) {
            return user.email
        }

        if (user && user.username) {
            return user.username
        }

        return ""
    }

    return (
      <AppBar position="sticky" component="header">
          <Toolbar className={styles.toolbar}>
              <img src="/Logo_White_Cut_Cardiolyse.svg" alt={Title()} className={styles.logo}/>
              <div className={styles.languages_container}>
                  {supportedLanguages.map((l, i) => (
                    <React.Fragment key={l}>
                                <span
                                  className={`${styles.languages_item} ${i18n.language === l && styles.languages_item__active}`}
                                  onClick={() => i18n.changeLanguage(l)}
                                >
                                    {languageLabel(l)}
                                </span>
                        {i < supportedLanguages.length - 1 && (
                          <span className={styles.languages_separator}>|</span>
                        )}
                    </React.Fragment>
                  ))}
              </div>
              <UiSkinToggle/>
              {user !== null && (
                matches ? (
                  <SignOutButton className={styles.sign_out_button__inline}/>
                ) : (
                  <div className={styles.user_container}>
                      <Button>
                          <Avatar className={styles.user_avatar}>
                              {getUserEmail()[0]}
                          </Avatar>
                          <span className={styles.user_email}>
                                {getUserEmail()}
                            </span>
                      </Button>
                      <SignOutButton className={styles.sign_out_button}/>
                  </div>
                )
              )}
          </Toolbar>
      </AppBar>
    )
}

export default withUser(Header)
